'use client';

import { GoogleTagManager } from '@next/third-parties/google';
import { useCookieConsentStatus } from '@/providers/CookieConsentProvider';
interface GTMScriptLoaderProps {
  gtmId: string;
  gtmScriptUrl: string;
}

/**
 * Loads Google Tag Manager script only when user has given consent
 * For EU users: waits for explicit consent
 * For non-EU users: loads immediately
 */
export default function GTMScriptLoader({
  gtmId,
  gtmScriptUrl
}: GTMScriptLoaderProps) {
  const {
    hasAnalyticsConsent,
    requiresConsent
  } = useCookieConsentStatus();

  // For EU users, wait for analytics consent before loading GTM
  const shouldLoadGTM = !requiresConsent || hasAnalyticsConsent;
  if (!shouldLoadGTM) {
    return null;
  }
  return <GoogleTagManager gtmScriptUrl={gtmScriptUrl} gtmId={gtmId} data-sentry-element="GoogleTagManager" data-sentry-component="GTMScriptLoader" data-sentry-source-file="GTMScriptLoader.tsx" />;
}